import useResetState from "../../../../Vote/Utilities/hooks/useResetState";
import _ from "lodash";
import React, {useEffect, useState} from "react";
import voteViews from "../../../../Vote/Utilities/voteViews";
import {Grid} from "@mui/material";
import styles from "../../../../Vote/voteMainStyles";
import ConversationContainer from "../../../../Vote/Sections/BodySection/Conversation/ConversationContainer";
import {Box} from "@mui/system";
import Response from "../../../../Vote/Sections/BodySection/Response/Response";
import SearchResultContainer from "../../../../Vote/Sections/BodySection/Search/SearchResultContainer";
import SearchedMessageConversation from "../../../../Vote/Sections/BodySection/Search/SearchedMessageConversation";
import SearchContainer from "../../../../Vote/Sections/BodySection/Search/SearchContainer";
import useGetMessageDetails from "../../Utilities/hooks/useGetMessageDetails";
import useGetMessageDetailsConversation from "../../Utilities/hooks/useGetMessageDetailsConversation";
import useViewResponseOptions from "../../Utilities/hooks/useViewResponseOptions";
import useGetOrgDataSourceHandles from "../../../../Vote/Utilities/hooks/useGetOrgDataSourceHandles";
import {
    customFieldActionsCreator,
    isCustomFieldSupported
} from "../../../../Vote/Sections/BodySection/Response/CustomField/CustomFieldUtils";
import {customFieldActions} from "../../../../../../../_actions";
import {useDispatch} from "react-redux";

export default function MessageDetailsBodySection({ isScrollComplete, editedResponseObj, editedSubjectObj }) {
    useResetState();
    const { message, loadingMessage } = useGetMessageDetails();
    const { conversation, loading } = useGetMessageDetailsConversation();
    const { responseOptions, loadingResponseOptions } = useViewResponseOptions();
    const dispatch = useDispatch();
    const withDm = _.get(message, 'canReplyPrivately') || _.get(message, 'teamsAttributes.canReplyPrivately');
    const [view, setView] = useState(voteViews.response);
    const organizationId = message?.organization?.id || message?.msgDataSource?.organization?.id;
    const msgDataSourceId = message?.msgDataSource?.id
    const msgSourceName = message?.msgDataSource?.msgSource?.name || message?.sourceName
    useGetOrgDataSourceHandles(organizationId);

    const toggleView = (view) => {
        setView(view);
    }

    useEffect(() => {
        if(msgDataSourceId && msgSourceName){
            const sourceName = msgSourceName.toLowerCase()
            if(isCustomFieldSupported(sourceName)) {
                dispatch(customFieldActions.listCustomFields(msgDataSourceId, customFieldActionsCreator.messageView));
            }
        }
    }, [msgDataSourceId, msgSourceName]);

    return (
        <Grid container sx={styles.rootPanel}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <ConversationContainer
                    conversation={conversation}
                    message={message}
                    loading={loading}
                    isScrollComplete={isScrollComplete}
                    withDm={withDm}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                {
                    view === voteViews.response &&
                    <Box sx={styles.responseContainer}>
                        <Response
                            responseOptions={responseOptions}
                            loadingMessage={loadingMessage}
                            isScrollComplete={isScrollComplete}
                            editedResponseObj={editedResponseObj}
                            editedSubjectObj={editedSubjectObj}
                            msgSourceName={msgSourceName}
                        />
                    </Box>
                }
                {
                    view === voteViews.searchResult &&
                    <Box sx={styles.searchResultContainer}>
                        <SearchResultContainer
                            handleBackToResponses={toggleView}
                            handleSearchedConversationViewToggle={toggleView}
                        />
                    </Box>
                }
                {
                    view === voteViews.searchedMessageConversation &&
                    <Box sx={styles.searchedMessageConversationContainer}>
                        <SearchedMessageConversation
                            handleBackToResult={toggleView}
                        />
                    </Box>
                }

                <Box sx={styles.searchContainer}>
                    <SearchContainer
                        handleSearchViewToggle={toggleView}
                        isScrollComplete={isScrollComplete}
                    />
                </Box>
            </Grid>
        </Grid>
    )
}